import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SiaSoundService {
  private okAudio: HTMLAudioElement | null = null;
  private errorAudio: HTMLAudioElement | null = null;
  private unlocked = false;
  private unlockHandler: (() => void) | null = null;
  // removeEventListener con options richiede lo STESSO riferimento passato ad addEventListener:
  // si memorizza qui una volta sola cosi' add e remove combaciano senza cast.
  private readonly captureOpts: AddEventListenerOptions = { passive: true, capture: true };

  constructor() {
    // Gli elementi audio vengono creati al bootstrap (non lazy) perche' la autoplay policy
    // mobile richiede che l'HTMLAudioElement ESISTA gia' nel momento in cui avviene il primo
    // gesto utente: solo cosi' lo "sblocco muto" puo' essere eseguito dentro quel gesto e il
    // suono potra' poi essere riprodotto programmaticamente (es. da uno scanner in outlet radar
    // che parte da un evento automatico della fotocamera, non da un tocco).
    if (typeof Audio !== 'undefined') {
      this.okAudio = new Audio('assets/sounds/ok.mp3');
      this.okAudio.preload = 'auto';
      this.okAudio.volume = 0.5;

      this.errorAudio = new Audio('assets/sounds/error.mp3');
      this.errorAudio.preload = 'auto';
      this.errorAudio.volume = 0.5;
    }

    this.armUnlockListener();
  }

  private armUnlockListener(): void {
    if (this.unlocked || this.unlockHandler) return;
    if (typeof document === 'undefined') return;
    this.unlockHandler = () => this.unlock();
    document.addEventListener('pointerdown', this.unlockHandler, this.captureOpts);
  }

  private removeUnlockListener(): void {
    if (!this.unlockHandler || typeof document === 'undefined') {
      this.unlockHandler = null;
      return;
    }
    document.removeEventListener('pointerdown', this.unlockHandler, this.captureOpts);
    this.unlockHandler = null;
  }

  unlock(): void {
    if (this.unlocked) {
      this.removeUnlockListener();
      return;
    }
    this.unlocked = true;
    this.removeUnlockListener();
    // Lo sblocco DEVE avvenire dentro un gesto utente: si riproduce ogni elemento in mute e lo
    // si rimette subito in pausa, cosi' il browser lo marca come "attivato" e consentira' le
    // riproduzioni programmatiche successive anche fuori da un gesto (es. con camera attiva).
    for (const el of [this.okAudio, this.errorAudio]) {
      if (!el) continue;
      el.muted = true;
      el.play()
        .then(() => {
          el.pause();
          el.currentTime = 0;
          el.muted = false;
        })
        .catch(() => {
          el.muted = false;
        });
    }
  }

  playOk(): void {
    if (!this.okAudio) return;
    this.okAudio.currentTime = 0;
    this.okAudio.play().catch(() => {});
  }

  playError(): void {
    if (!this.errorAudio) return;
    this.errorAudio.currentTime = 0;
    this.errorAudio.play().catch(() => {});
  }
}
